import { useState } from "react";
import classNames from "classnames";
import { useRef } from "react";
import { useClickOutside } from "elseware-ui";

import HeaderNavItemContext from "./HeaderNavItemContext";

import { BsChevronDown } from "react-icons/bs";

function HeaderNavGroup({
  icon,
  name,
  description,
  badge,
  to,
  styles,
  children,
  navigate,
}) {
  const [collapsed, setCollapsed] = useState(true);
  const headerNavGroupRef = useRef();
  useClickOutside(headerNavGroupRef, () => setCollapsed(true));

  const handleNavigation = () => {
    if (to) {
      if (to) {
        if (navigate) {
          navigate(to); // SPA navigation
        } else {
          window.location.href = to;
        }
      }
    }
  };

  return (
    <div className="relative w-full" ref={headerNavGroupRef}>
      <div
        className={classNames({
          "flex flex-row gap-2 items-center justify-between cursor-pointer p-3 w-full": true,
          "transition-all duration-300 ease-in-out": true,
          "hover:bg-gray-300 dark:hover:bg-dark-600": true,
          "bg-gray-300 dark:bg-dark-500": !collapsed,
          [`${styles}`]: styles,
        })}
        onClick={() => {
          if (children) {
            setCollapsed(!collapsed);
          } else {
            handleNavigation();
          }
        }}
      >
        <div>
          <HeaderNavItemContext
            icon={icon}
            name={name}
            description={description}
            badge={badge}
          />
        </div>
        {children && (
          <BsChevronDown
            className={classNames({
              "text-md": true,
              "transition-all ease-in-out duration-300": true,
              "rotate-180": !collapsed,
            })}
          />
        )}
      </div>
      {!collapsed && children && (
        <div
          className={classNames({
            "absolute min-w-80 left-0 top-full mt-1 bg-white dark:bg-dark-900 shadow-md rounded-md z-50 w-full": true,
            "transition-all duration-300 ease-in-out": true,
          })}
        >
          {children}
        </div>
      )}
    </div>
  );
}

export default HeaderNavGroup;
